
import { Component, Vue } from 'vue-property-decorator';
import { BModal } from 'bootstrap-vue';
import { IndividualFileCategories } from 'ah-api-gateways';
import AsyncImage from '@/app/components/common/AsyncImage.vue';
import UserIcon from './UserIcon.vue';
import { useAuthStore } from '@/app/store/authModule';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';

@Component({
  components: {
    AsyncImage,
    UserIcon,
  },
})
export default class UserIconMenuMobile extends Vue {
  $refs!: {
    userMenuDropdown: Vue;
    deleteModal: BModal;
  };
  show = false;

  created() {
    if (this.authStore.isClientUser) {
      this.individualSettingsStore.loadIndividualDocuments();
    }
  }

  toggleShow() {
    this.show = !this.show;
  }

  get authStore() {
    return useAuthStore();
  }

  get individualSettingsStore() {
    return useIndividualSettingsStore();
  }

  get photo() {
    return this.individualSettingsStore.getIndividualDocument(IndividualFileCategories.PROFILE_PICTURE);
  }

  get settingsBase() {
    if (this.authStore.isAgent) {
      return '/admin/settings';
    }
    return '/settings';
  }

  logout() {
    this.$refs.deleteModal.show();
    this.$refs.deleteModal.$once('ok', () => this.authStore.logout());
  }

  get initials() {
    return ((this.user!.firstName || ' ')[0] + (this.user!.lastName || ' ')[0]).toUpperCase();
  }

  get user() {
    return this.authStore.loggedInIdentity;
  }
}
